var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['voucher']},[_vm._t("main",[_c('div',{staticClass:"main"},[_vm._v("$"+_vm._s(_vm.amount))])]),_vm._t("footer",[_c('div',{staticClass:"footer"},[_vm._v(_vm._s(_vm.footerText))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }